<template>
    <v-layout row wrap>
        <v-flex xs12 v-if="loading">
            <v-progress-linear :indeterminate="true"></v-progress-linear>
        </v-flex>
        <v-flex xs12 v-if="!loading">
            <v-card flat>
                <v-card-title class="primary white--text headline">
                    {{ 'Notifications'|translate }}
                    <v-spacer></v-spacer>
                    <v-chip class="non-interactive-chip"><strong><span>{{ 'Total'|translate }} : {{this.$store.getters.notificationCount}}</span></strong></v-chip>
                    <v-chip class="non-interactive-chip"><strong><span>{{ 'Unack'|translate }} : {{this.$store.getters.recentNotificationsCount}}</span></strong></v-chip>
                    <v-chip class="non-interactive-chip"><strong><span style="color:#5A89D7">{{ 'Low'|translate }} : {{this.$store.getters.lowSeverityNotificationsCount}}</span></strong></v-chip>
                    <v-chip class="non-interactive-chip"><strong><span style="color:#E7AC19">{{ 'Medium'|translate }} : {{this.$store.getters.mediumSeverityNotificationsCount}}</span></strong></v-chip>
                    <v-chip class="non-interactive-chip"><strong><span style="color:#e65000">{{ 'High'|translate }} : {{this.$store.getters.highSeverityNotificationsCount}}</span></strong></v-chip>
                    <v-chip class="non-interactive-chip"><strong><span style="color:red">{{ 'Critical'|translate }} : {{this.$store.getters.criticalSeverityNotificationsCount}}</span></strong></v-chip>
                </v-card-title>
                <v-layout row wrap>
                    <span style="width:90px" class="ml-3">
                        <v-select
                            v-model="rangeDays"
                            :items="rangeDaysOptions"
                            :label="'Range'|translate"
                            single-line></v-select>
                        </span>
                    <span style="width:300px" class="ml-3">
                    <v-text-field clearable v-model="search" type="text"
                                  :label="'Keyword filter'|translate"></v-text-field>
                    </span>
                    <span style="width:300px">
                        <v-switch color="success" class="ml-3" v-model="showRecent"
                                  :label="'Show Unack Notifications Only'|translate"></v-switch>
                    </span>
                    <v-spacer></v-spacer>

                </v-layout>
                <v-tabs v-model="tab" class="mt-2 ml-3">
                    <v-tab :key="1">
                        <v-chip color="orange" text-color="white">
                            <v-avatar class="orange darken-4">{{ items1.length }}</v-avatar>
                            {{ 'Critical/High/Medium'|translate }}
                        </v-chip>
                    </v-tab>
                    <v-tab :key="2">
                        <v-chip color="blue" text-color="white">
                            <v-avatar class="blue darken-4">{{ items2.length }}</v-avatar>
                            {{ 'Low'|translate }}
                        </v-chip>
                    </v-tab>
                    <v-tab :key="3" v-if="items3&&items3.length>0">
                        <v-chip color="green" text-color="white">
                            <v-avatar class="green darken-4">{{ items3.length }}</v-avatar>
                            {{ 'Anomaly'|translate }}
                        </v-chip>
                    </v-tab>
                    <v-tab-item :key="1">
                        <v-layout row>
                            <v-spacer>
                            </v-spacer>
                            <v-btn class="accent" @click="exportNotification(items1)" style="margin-top: -40px">
                                <v-icon small class="mr-2">fa-download</v-icon>
                                {{ 'Download'|translate }}
                            </v-btn>
                            <v-btn class="accent mr-3" @click="exportNotifWithMR(items1)" style="margin-top: -40px">
                                <v-icon small class="mr-2">fa-download</v-icon>
                                {{ 'Download with Maintenance'|translate }}
                            </v-btn>
                        </v-layout>
                        <notification-list-widget
                            :external-items="items1"
                            :show-recent="showRecent"
                            :show-maintenance-records="true"
                            :show-mute-action="true"
                            :bare-mode="true"
                            :hide-filters="true"
                        ></notification-list-widget>
                    </v-tab-item>
                    <v-tab-item :key="2">
                        <v-layout row>
                            <v-spacer>
                            </v-spacer>
                            <v-btn class="accent" @click="exportNotification(items2)"  style="margin-top: -40px">
                                <v-icon small class="mr-2">fa-download</v-icon>
                                {{ 'Download'|translate }}
                            </v-btn>
                            <v-btn class="accent mr-3" @click="exportNotifWithMR(items2)"  style="margin-top: -40px">
                                <v-icon small class="mr-2">fa-download</v-icon>
                                {{ 'Download with Maintenance'|translate }}
                            </v-btn>
                        </v-layout>
                        <notification-list-widget
                            :show-recent="showRecent"
                            :external-items="items2"
                            :show-maintenance-records="true"
                            :show-mute-action="true"
                            :bare-mode="true"
                            :hide-filters="true"
                        ></notification-list-widget>
                    </v-tab-item>
                    <v-tab-item :key="3" v-if="items3&&items3.length>0">
                        <v-layout row>
                            <v-spacer>
                            </v-spacer>
                            <v-btn class="accent" @click="exportNotification(items3)"  style="margin-top: -40px">
                                <v-icon small class="mr-2">fa-download</v-icon>
                                {{ 'Download'|translate }}
                            </v-btn>
                            <v-btn class="accent mr-3" @click="exportNotifWithMR(items3)"  style="margin-top: -40px">
                                <v-icon small class="mr-2">fa-download</v-icon>
                                {{ 'Download with Maintenance'|translate }}
                            </v-btn>
                        </v-layout>
                        <notification-list-widget
                            :external-items="items3"
                            :show-recent="showRecent"
                            :show-maintenance-records="true"
                            :show-mute-action="true"
                            :bare-mode="true"
                            :hide-filters="true"
                        ></notification-list-widget>
                    </v-tab-item>
                </v-tabs>
                <notification-detail-dialog
                    v-model="dialog"
                    :item="currentItem"
                    :maintenance-headers="maintenanceHeaders"
                    @jump-to-link="jumpToLink"
                    @jump-to-link-nw="jumpToLinkNW"
                    @trigger="trigger"
                    @mute="muteNotif"
                    @refresh="refresh"
                ></notification-detail-dialog>
            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>
import {getNotification} from '@/helper'
import FaultRecordDialog from '../components/FaultRecordDialog'
import SeverityChip from '../components/SeverityChip'
import {putNotification, getMaintenanceRecords, getPoint} from '../helper'
import {exportCSV} from '../tocsv'
import ValueBox from "../components/ValueBox";
import _ from 'lodash'
import moment from 'moment'
import MaintenanceRecord from "./MaintenanceRecord.vue";
import NotificationListWidget from "../components/widgets/NotificationListWidget.vue";
import NotificationDetailDialog from "../components/NotificationDetailDialog.vue";

export default {
    name: 'Notifications2',
    components: {SeverityChip, FaultRecordDialog, ValueBox,MaintenanceRecord,NotificationListWidget,NotificationDetailDialog},
    data() {
        return {
            activeFacets: {},
            facetOptions: {},
            toggle_exclusive: 1,
            dialog: false,
            rangeDays: 90,
            rangeDaysOptions: [{
                text: this.$options.filters.translate('30 days'),
                value: 30
            }, {
                text: this.$options.filters.translate('90 days'),
                value: 90
            }, {
                text: this.$options.filters.translate('1 year'),
                value: 365
            }, {text: this.$options.filters.translate('all'), value: null}],
            maxDate: moment(),
            showRecent: true,
            tab: 0,
            items: null,
            search: '',
            search2: '',
            maintenanceDialog: false,
            maintenanceItem: null,
            maintenanceHeaders: [
                {
                    text: this.$options.filters.translate('ID'),
                    align: 'left',
                    sortable: true,
                    value: 'maintenance_id'
                },
                {
                    text: this.$options.filters.translate('Fault'),
                    align: 'left',
                    sortable: true,
                    value: 'maintenance_label'
                },
                {text: this.$options.filters.translate('Fixed'), value: 'is_fixed'},
                {text: this.$options.filters.translate('Assigned to'), value: 'assigned_to'},
                {text: this.$options.filters.translate('Assigned by'), value: 'assigned_by'},
                {text: this.$options.filters.translate('Assigned date'), value: 'assigned_date'},
                {text: this.$options.filters.translate('Actions'), sortable: false},
            ],
            facets: {
                "floor": this.$options.filters.translate("Floor"),
                "equipment_name": this.$options.filters.translate("Equipment"),
                "severity": this.$options.filters.translate("Severity"),
                "equipment_type": this.$options.filters.translate("Equipment Type"),
                "title": this.$options.filters.translate("Issue"),
                "topic": this.$options.filters.translate("Topic"),
            },
            currentItem: {
                icon: 'fa-bell',
                title: 'Condenser Cleaning Required in Chiller 1',
                equip: 'Chiller 1',
                startDate: '',
                endDate: '',
                to: {
                    path: '/sensors',
                    query: {
                        onOnly: true,
                        variableX: 'Cond_Approach',
                        variableY: 'Cond_Approach',
                        rangeStart: '2018-01-01',
                        rangeEnd: '2018-06-30',
                        equipment: 'Chiller 1'
                    }
                },
                description: "Condenser Approach High in Chiller 1",
                recommendedActions: [
                    'Clean Condenser Tubes',
                    'Check Condenser Water Pumps',
                ].join('\n')
            },
            facetGraphs: [],
            loading: true,
            rawNotifs: null,
            rawMRs: null,
            notifs: null,
        }
    },
    watch: {
        search() {
            this.debounce(this.syncSearches, 500);
        },
        showRecent(newValue) {
            this.getData(newValue)
        },
        rangeDays() {
            this.getData(this.showRecent)
        }
    },
    computed: {
        headers() {
            return [
                {
                    text: this.$options.filters.translate('ID'),
                    align: 'left',
                    sortable: true,
                    value: 'notification_id'
                }, {
                    text: this.$options.filters.translate('Alerts'),
                    align: 'left',
                    sortable: true,
                    value: 'title'
                },
                {text: this.$options.filters.translate('Equipment'), value: 'equip'},
                {text: this.$options.filters.translate('Equipment Type'), value: 'equipType', sortable: true},
                {text: this.$options.filters.translate('Topic'), value: 'topic', sortable: true},
                {text: this.$options.filters.translate('Floor'), value: 'floor', sortable: true},
                {text: this.$options.filters.translate('Description'), value: 'description'},
                {text: this.$options.filters.translate('Start Date'), value: 'startDate'},
                {text: this.$options.filters.translate('End Date'), value: 'endDate'},
                {text: this.$options.filters.translate('Severity'), value: 'severity'},
                {text: this.$options.filters.translate('Assigned to'), value: 'acknowledged'},
                {text: this.$options.filters.translate('Fixed'), value: 'acknowledged'},
                {text: this.$options.filters.translate('Acknowledged'), value: 'acknowledged'},
                {text: this.$options.filters.translate('Actions'), value: 'name', sortable: false}
            ]
        },
        items1() {
            if (!this.items) {
                return []
            }
            let filtered = this.items.filter(x => !(x.topic === "anomaly" || x.title.toLowerCase().startsWith("anomaly")) && (x.severity.toLowerCase() === "critical" || x.severity.toLowerCase() === "high" || x.severity.toLowerCase() === "medium"))
            if (this.showRecent) {
                filtered = filtered.filter(x => !x.acknowledged)
            }
            if (this.search2 && this.search2 !== "") {
                filtered = filtered.filter(x => this.filterItemProperly(x))
            }
            return filtered
        },
        items2() {
            if (!this.items) {
                return []
            }
            let filtered = this.items.filter(x => !(x.topic === "anomaly" || x.title.toLowerCase().startsWith("anomaly")) && (x.severity.toLowerCase() === "low"))
            if (this.showRecent) {
                filtered = filtered.filter(x => !x.acknowledged)
            }
            if (this.search2 && this.search2 !== "") {
                filtered = filtered.filter(x => this.filterItemProperly(x))
            }
            return filtered
        },
        items3() {
            if (!this.items) {
                return []
            }
            let filtered = this.items.filter(x => (x.topic === "anomaly" || x.title.toLowerCase().startsWith("anomaly")))
            if (this.showRecent) {
                filtered = filtered.filter(x => !x.acknowledged)
            }
            if (this.search2 && this.search2 !== "") {
                filtered = filtered.filter(x => this.filterItemProperly(x))
            }
            return filtered
        },
    },
    methods: {
        filterItemProperly(item){
            if (item.maintenance_records){
                let {maintenance_records, ...itemWithoutMR} = item;
                return JSON.stringify(Object.values(itemWithoutMR)).toLowerCase().indexOf(this.search2.toLowerCase()) > -1
            } else {
                return JSON.stringify(Object.values(item)).toLowerCase().indexOf(this.search2.toLowerCase()) > -1
            }
        },
        refresh() {
            this.maintenanceDialog = false
            this.maintenanceItem = null
            this.dialog = false
            this.getData(this.showRecent)
        },
        syncSearches() {
            this.search2 = this.search
        },
        debounce(callback, wait) {
            clearTimeout(this.timeout);
            this.timeout = setTimeout(() => callback(), wait);
        },
        jumpToLinkNW(item) {
            let output = this.getItemUrl(item)
            if (process.env.VUE_APP_SINGLE_WINDOW_MODE) {
                this.$router.push(output)
            } else {
                if (item.to && item.to.external_domain) {
                    window.open(item.to.external_domain + this.$router.resolve(output).href)
                } else {
                    window.open(this.$router.resolve(output).href)
                }
            }
        },
        async trigger(id, state) {
            await putNotification(
                {
                    'facility_name': this.$store.state.pointsListStore.pointsList.facility_name,
                    'notification_id': id,
                    'show_flag': state
                }
            )
            // Update local state
            if (this.currentItem && this.currentItem.notification_id === id) {
                this.currentItem.acknowledged = !state
            }
        },
        async muteNotif(id, state) {
            await putNotification(
                {
                    'facility_name': this.$store.state.pointsListStore.pointsList.facility_name,
                    'notification_id': id,
                    'mute_notif': state
                }
            )
            // Update local state
            if (this.currentItem && this.currentItem.notification_id === id) {
                this.currentItem.muted = state
            }
        },
        async getPointStatusesByEquipment() {
            let response = await getPoint({
                facility_name: this.$store.state.pointsListStore.pointsList.facility_name,
            })
            return (response.result || []).reduce((statusesByEquipment, point) => {
                if (!point.equipment_name || !point.meta || !Array.isArray(point.meta.point_status)) {
                    return statusesByEquipment
                }
                let pointStatuses = point.meta.point_status.filter(status => status !== null && status !== 'null')
                if (pointStatuses.length === 0 || _.isEqual(pointStatuses, ['ok'])) {
                    return statusesByEquipment
                }
                if (!statusesByEquipment[point.equipment_name]) {
                    statusesByEquipment[point.equipment_name] = []
                }
                statusesByEquipment[point.equipment_name].push(`${point.sensor_name}: ${pointStatuses.join(', ')}`)
                return statusesByEquipment
            }, {})
        },
        async exportNotification(items) {
            let pointStatusesByEquipment = await this.getPointStatusesByEquipment()
            let exportables=[]
            let cleanedItems = JSON.parse(JSON.stringify(items))
            for (let item of cleanedItems) {
                item.url = item.to && item.to.external_domain ? item.to.external_domain + this.$router.resolve(this.getItemUrl(item)).href : window.location.origin + this.$router.resolve(this.getItemUrl(item)).href
                delete (item.to)
                delete (item.icon)
                delete (item.maintenance_records)
                let newitem={
                    ID: item.notification_id,
                    Alerts: item.title,
                    Equipment: item.equip,
                    "Equipment Type": item.equipType,
                    Topic: item.topic,
                    Floor: item.floor,
                    Description: item.description,
                    "Start Date": item.startDate,
                    "End Date": item.endDate,
                    Severity: item.severity,
                    Acknowledged:item.acknowledged ? "Yes" : "No",
                    URL: item.url,
                    "Alert Type": item.alertType,
                    "Recommended Actions": item.recommendedActions,
                    "Point Status": (pointStatusesByEquipment[item.equip] || []).join(', '),
                }
                if (!newitem["Recommended Actions"]) {
                    delete (newitem["Recommended Actions"])
                }
                exportables.push(newitem)
            }
            exportCSV(exportables)
        },
        async exportNotifWithMR(items) {
            let pointStatusesByEquipment = await this.getPointStatusesByEquipment()
            let cleanedItems = JSON.parse(JSON.stringify(items))
            let newItems = []
            let filledKeys = ["alertType", "title", "equip", "equipType", "floor", "startDate", "endDate", "topic", "occurredTimes", "description", "recommendedActions", "severity", "notification_id", "acknowledged", "url", "maintenance_id", "maintenance_text", "maintenance_label", "maintenance_date_from", "maintenance_date_to", "is_fixed", "fixed_by", "fixed_date", "assigned_by", "assigned_to", "assigned_date", "updated_on", "created_on", "equipment"]
            for (let item of cleanedItems) {
                item.url = item.to && item.to.external_domain ? item.to.external_domain + this.$router.resolve(this.getItemUrl(item)).href : window.location.origin + this.$router.resolve(this.getItemUrl(item)).href
                delete (item.to)
                delete (item.icon)
                let newitem={
                    ID: item.notification_id,
                    Alerts: item.title,
                    Equipment: item.equip,
                    "Equipment Type": item.equipType,
                    Topic: item.topic,
                    Floor: item.floor,
                    Description: item.description,
                    "Start Date": item.startDate,
                    "End Date": item.endDate,
                    Severity: item.severity,
                    Acknowledged:item.acknowledged ? "Yes" : "No",
                    URL: item.url,
                    "Alert Type": item.alertType,
                    "Recommended Actions": item.recommendedActions,
                    "Point Status": (pointStatusesByEquipment[item.equip] || []).join(', '),
                }
                if (!newitem["Recommended Actions"]) {
                    delete (newitem["Recommended Actions"])
                }
                if (!item.maintenance_records || item.maintenance_records.length === 0) {
                    for (let key of filledKeys) {
                        if (typeof (newitem[key]) === "undefined") {
                            newitem[key] = ""
                        } else {
                            //newitem[key] = newitem[key]
                        }
                    }
                    newItems.push(newitem)
                } else {
                    for (let mr of item.maintenance_records) {
                        let itemBase = JSON.parse(JSON.stringify(newitem))
                        itemBase = Object.assign(itemBase, mr)
                        delete (itemBase.equipment_name)
                        delete (itemBase.equipment_id)
                        delete (itemBase.equipment)
                        delete (itemBase.exclude_in_model)
                        delete (itemBase.comments)
                        newItems.push(itemBase)
                    }
                }

            }
            exportCSV(newItems)
        },
        getMaintenanceItem(item) {
            let itemUrlObj = this.getItemUrl(item)
            return {
                facility_name: this.$store.state.pointsListStore.pointsList.facility_name,
                equipment: item['equip'],
                maintenance_date_from: item['startDate'],
                maintenance_date_to: item['endDate'],
                severity: item['severity'],
                maintenance_text: this.$options.filters.translate('Recommended Actions:') + ' \n\n' + item['recommendedActions'],
                maintenance_label: item['title'],
                url: this.$router.resolve(itemUrlObj).href,
                notification_id: item['notification_id'],
                is_fixed: false,
                maintenance_id: null
            }
        },
        callMaintenanceDialog(item, dialogOpen = true) {
            this.maintenanceItem = this.getMaintenanceItem(item)
            this.maintenanceDialog = dialogOpen
        },
        callDialog(item) {
            this.dialog = true
            this.currentItem = item
        },
        getItemUrl(item) {
            let output = null;
            if (item.title.substring(0, 7) === "Anomaly") {
                output = {
                    path: '/modelsummary',
                    query: {
                        rangeStart: item.to.query.rangeStart,
                        rangeEnd: item.to.query.rangeEnd,
                        equipment: item.equip
                    }
                }
            } else if (item.topic === "equipment health") {
                output = {
                    path: '/equipment-health',
                    query: {
                        equipment: item.equip,
                    }
                }
            } else {
                output = {
                    path: '/fault-analysis',
                    query: {
                        relevantVariables: item.to.query.variableX,
                        faultName: item.title,
                        faultDesc: item.description,
                        rangeStart: item.to.query.rangeStart,
                        rangeEnd: item.to.query.rangeEnd,
                        equipmentName: item.equip,
                        nId: item.notification_id,
                        nTopic: item.topic,
                        nOct: item.occurredTimes
                    }
                }
            }
            return output
        },
        jumpToLink(item) {
            let output = this.getItemUrl(item)
            if (item.to && item.to.external_domain) {
                window.open(item.to.external_domain + this.$router.resolve(output).href)
            } else {
                this.$router.push(output)
            }
            // this.$store.dispatch('updateMaintenanceItem', this.getMaintenanceItem(item))
            // this.$router.push(item.to)
        },
        jumpToMR(item) {
            let output = {
                path: "/maintenancerecord",
                query: {
                    rangeStart: item.to.query.rangeStart,
                    rangeEnd: item.to.query.rangeEnd,
                }
            }
            if (item.to && item.to.external_domain) {
                window.open(item.to.external_domain + this.$router.resolve(output).href)
            } else {
                this.$router.push(output)
            }

        },

        getData(ignore_acknowledged) {
            let me = this;
            // me.loading = true
            let range = null
            if (me.rangeDays) {
                range = [moment(me.maxDate).subtract(me.rangeDays, "days").format('YYYY-MM-DD'), moment(me.maxDate).format('YYYY-MM-DD') + " 23:59:59"]
            }
            let promises = [getNotification({
                facility_name: this.$store.state.pointsListStore.pointsList.facility_name,
                ignore_acknowledged: ignore_acknowledged,
                date_range: range,
            }), getMaintenanceRecords({
                facility_name: this.$store.state.pointsListStore.pointsList.facility_name,
                date_range: range ? {start: range[0], end: range[1]} : null
            })]
            Promise.all(promises).then(function (responses) {
                me.rawNotifs = responses[0].result
                me.rawMRs = responses[1].result
                me.refineNotifs()
            })

        },
        refineNotifs() {
            let me = this
            let notifs = me.rawNotifs
            let items = []
            for (let i in notifs) {
                let notification_id = notifs[i]['notification_id']
                items.push({
                    icon: 'fa-bell',
                    alertType: notifs[i]['model'],
                    title: notifs[i]['title'],
                    equip: notifs[i]['equipment_name'],
                    equipType: notifs[i]['equipment_type'],
                    floor: notifs[i]['floor'],
                    startDate: notifs[i]['start_date'],
                    endDate: notifs[i]['end_date'],
                    topic: notifs[i]['topic'],
                    occurredTimes: notifs[i]['occurred_times'],
                    to: notifs[i]['to'],
                    description: notifs[i]['description'],
                    recommendedActions: notifs[i]['recommended_actions'],
                    severity: notifs[i]['severity'],
                    notification_id: notification_id,
                    acknowledged: notifs[i]['acknowledged'],
                    maintenance_records: me.rawMRs.filter(x => x.notification_id && x.notification_id === notification_id),
                    muted: notifs[i]['muted'],
                    ack_by: notifs[i]['ack_by'],
                    last_ack_date: notifs[i]['last_ack_date'],
                    muted_by: notifs[i]['muted_by'],
                    muted_date: notifs[i]['muted_date']
                })
            }
            me.items = items = _.sortBy(items, ['startDate']).reverse()
            me.loading = false
            let id = _.get(this.$route.query, 'id', null)
            if (id) {
                let found = me.items.filter(x => x.notification_id && x.notification_id == id)
                if (found && found.length > 0) {
                    me.callDialog(found[0])
                    me.$router.replace({
                        path: me.$router.currentRoute.path,
                        query: {}
                    }).catch(err => {
                    })
                }
            }
        }
    },
    beforeMount() {
        let id = _.get(this.$route.query, 'id', null)
        if (id) {
            this.rangeDays = null
        }
    },
    mounted() {
        let maxDate = this.$store.state.pointsListStore.pointsList.data_max_date;
        if (maxDate) {
            this.maxDate = moment(maxDate)
        }
        this.getData(this.showRecent);
    },


}
</script>

<style scoped>
.non-interactive-chip {
    pointer-events: none;
}
</style>